import { inject } from 'vue'

export const useEditProfileModeInjector = () => {
  return {
    isEditModeEnabled: inject('isEditModeEnabled'),
    toggleEditMode: inject('toggleEditMode'),
    enableEditMode: inject('enableEditMode'),
    disableEditMode: inject('disableEditMode'),
  }
}
